<template>
  <div class="stock-logitics-info">
    <!-- tab -->
    <ContentHeader
      path-set-type="append"
      :path-info="navPathInfo"
      :show-back="true"
    />
    <div class="content-container" v-loading="loading">
      <!-- 头部 -->
      <div class="order-info-block">
        <div class="order-header">
          <div class="order-number">运单编号: {{ orderInfo.orderNumber }}</div>
          <div class="order-date" v-if="orderInfo.orderDate">
            运单时间: {{ orderInfo.orderDate | parseTime }}
            <span class="ongoing"
              >此订单已经进行了{{ getInterval(orderInfo.createDate) }}天</span
            >
          </div>
          <div class="order-status">
            订单状态: {{ orderInfo.orderStatusName }}
          </div>
        </div>
        <stockStatusStep
          v-if="orderInfo.orderStatus !== 900"
          ref="stockStatusStep"
          :order-type="'logitics'"
          :orderInfo="orderInfo"
        />
      </div>

      <!-- 主单信息 -->
      <div class="order-info-block">
        <div class="block-title">主单信息</div>
        <el-row :gutter="12">
          <el-form :model="orderInfo" label-width="120px">
            <el-col :span="8">
              <el-form-item label="运单编号">
                <span>{{ orderInfo.orderNumber }}</span>
              </el-form-item>
              <el-form-item label="类型及单号">
                <span
                  >{{ orderInfo.orderTypeName }}
                  {{ orderInfo.sourceNumber }}</span
                >
              </el-form-item>
              <el-form-item
                label="出库单名称"
                v-if="orderInfo.orderType === '01'"
              >
                <span>{{ orderInfo.stockOutName }}</span>
              </el-form-item>
              <el-form-item label="出库仓库">
                <span>{{ orderInfo.warehouseName }}</span>
              </el-form-item>
              <el-form-item label="运单状态">
                <span>{{ orderInfo.orderStatusName }}</span>
              </el-form-item>
              <el-form-item label="下单人">
                <span>{{ orderInfo.clientName }}</span>
              </el-form-item>
              <el-form-item label="发货人">
                <span>{{ orderInfo.consignPerson }}</span>
              </el-form-item>
              <el-form-item label="发货人手机">
                <span>{{ orderInfo.consignMobile }}</span>
              </el-form-item>
              <el-form-item label="是否自提" v-if="!orderInfo.isSelfDelivery">
                <span>{{ orderInfo.isSelfDelivery ? "是" : "否" }}</span>
              </el-form-item>
              <el-form-item label="自提人信息" v-else>
                <span>{{ orderInfo.selfDeliveryInfo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="实际发货日期">
                <span v-if="orderInfo.shipDate">{{
                  orderInfo.shipDate | parseTime("{y}-{m}-{d}")
                }}</span>
              </el-form-item>
              <el-form-item label="预计到达日期">
                <span v-if="orderInfo.preReachDate">{{
                  orderInfo.preReachDate | parseTime("{y}-{m}-{d}")
                }}</span>
              </el-form-item>
              <el-form-item label="收货人">
                <span>{{ orderInfo.receivePerson }} </span>
              </el-form-item>
              <el-form-item label="收货人手机">
                <span>{{ orderInfo.receiveMobile }}</span>
              </el-form-item>
              <el-form-item label="收货地址">
                <span v-if="!orderInfo.isSelfDelivery"
                  >{{ orderInfo.receiveProvinceName }}
                  {{ orderInfo.receiveCityName }}
                  {{ orderInfo.receiveCountyName }}
                  {{ orderInfo.receiveAddress }}</span
                >
                <span v-else>自提</span>
              </el-form-item>
              <el-form-item label="签收人">
                <span>{{ orderInfo.receiptUser }}</span>
              </el-form-item>
              <el-form-item label="实际签收日期">
                <span v-if="orderInfo.receiptDate">{{
                  orderInfo.receiptDate | parseTime("{y}-{m}-{d}")
                }}</span>
              </el-form-item>
              <el-form-item label="运单备注">
                <span>{{ orderInfo.orderRemark }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <!-- <el-form-item label="物流公司">
                <span>{{
                  getLogisticsCompany(orderInfo.logisticsCompany)
                }}</span>
              </el-form-item> -->
              <el-form-item label="物流公司">
                <span>{{ orderInfo.logisticsCompanyName }}</span>
              </el-form-item>
              <el-form-item label="运输方式">
                <span>{{ orderInfo.logisticsTypeName }}</span>
              </el-form-item>
              <el-form-item label="物流单号">
                <span>{{ orderInfo.logisticsNumber }}</span>
              </el-form-item>
              <el-form-item label="打包数量">
                <span>{{ orderInfo.packageNumber }}</span>
              </el-form-item>
              <el-form-item label="包裹重量">
                <span>{{ orderInfo.packageWeight }}</span>
              </el-form-item>
              <el-form-item label="计费重量">
                <span>{{ orderInfo.billingWeight }}</span>
              </el-form-item>
              <el-form-item label="包裹体积">
                <span>{{ orderInfo.packageBulk }}</span>
              </el-form-item>
              <el-form-item label="包裹说明">
                <span>{{ orderInfo.packageDesc }}</span>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>

      <!-- 订单明细 -->
      <div class="order-info-block">
        <div class="block-title">订单明细</div>
        <el-table
          :data="orderInfo.stockLogisticsDetailList"
          class="delivery-table"
        >
          <el-table-column
            label="品牌名称"
            align="center"
            prop="abiBrandName"
          />
          <el-table-column label="商品名称" align="center" prop="itemName" />
          <el-table-column label="商品编码" align="center" prop="itemCode" />
          <el-table-column label="数量" align="center" prop="itemQty" />
          <el-table-column label="区域编码 - 名称" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.orgCode }} - {{ scope.row.orgName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="品牌部门编码 - 名称" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.buType }} - {{ scope.row.buTypeName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="渠道" align="center" prop="channelCode" />
          <el-table-column label="申请人" align="center" prop="applyPerson" />
          <el-table-column v-if="orderInfo.orderType==='03'" label="售点名称" align="center" prop="pocName" />
          <el-table-column v-if="orderInfo.orderType==='03'" label="售点年销量" align="center" prop="pocTotalSale" />
          <el-table-column label="M1" align="center" prop="m1Name" />
          <el-table-column label="M2" align="center" prop="m2Name" />
          <el-table-column label="M3" align="center" prop="m3Name" />
          <el-table-column
            label="用途信息"
            align="center"
            prop="purposeInfo"
            show-overflow-tooltip
          />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import { mapState } from 'vuex'
import stockStatusStep from './components/stock-status-step'
export default {
  name: 'stock-logitics-info',
  components: {
    ContentHeader,
    stockStatusStep
  },
  data () {
    return {
      loading: false,
      orderInfo: {},
      logisticsId: ''
    }
  },
  computed: {
    navPathInfo () {
      let pathInfo = [{ path: '/stock/logitics', name: '运单查询' }]
      return pathInfo
    },
    ...mapState({
      logisticsCompanyList: state => state.base.logisticsCompanyMap
    })
  },
  created () {
    this.logisticsId = this.$route.query.logisticsId
    this.$store.dispatch('getDictByName', 'logisticsCompanyMap')
    this.init()
  },
  methods: {
    init () {
      this.getInfo()
    },
    getInfo () {
      this.loading = true
      this.$store
        .dispatch('querylogiticsOrderInfo', this.logisticsId)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.orderInfo = res.data.resultData.stockLogistics
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 获取间隔时间
    getInterval (time) {
      let date = new Date().getTime()
      let intervalDate = date - time
      return Math.floor(intervalDate / 86400000) + 1
    },
    getLogisticsCompany (val) {
      let name = ''
      if (this.logisticsCompanyList) {
        this.logisticsCompanyList.forEach(item => {
          if (item.key === val) {
            name = item.value
          }
        })
      }
      return name || val
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0;
}
.order-info-block {
  border-radius: 10px;
  background-color: $base-white;
  padding: 20px;
  margin-bottom: 20px;

  .block-title {
    line-height: 32px;
  }
}
.order-header {
  .order-number {
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
  }
  .order-date {
    font-size: 16px;
    line-height: 30px;
  }
  .ongoing {
    margin-left: 15px;
  }
  .order-status {
    color: $base-red;
    padding: 16px 0;
  }
}
.order-detail {
  width: 100%;
  .item-image {
    width: 65px;
    height: 65px;
    margin: 0 auto;
    border: 1px solid $base-grey;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    img {
      max-width: 90%;
      max-height: 90%;
    }
  }

  .item-name {
    text-align: left;
    font-weight: 700;
  }

  .item-sum {
    font-weight: 700;
  }
}

.order-amount {
  border: 2px dashed #db3e3e;
  margin: 10px 0 0 0;
  padding: 0 20px;
  color: #db3e3e;
  font-size: 16px;
  line-height: 32px;
}

.dotted-block {
  border: 2px dashed $base-grey3;
  vertical-align: middle;
  height: 80px;
}

.budget-info-block {
  padding: 0 30px 0 0;
  p {
    margin-top: 30px;
  }
}
.entity-info-block {
  padding: 0 30px 0 0;
  p {
    margin-top: 15px;
    & + p {
      margin-top: -5px;
    }
  }
}

.delivery-table {
  ::v-deep th {
    background-color: $base-grey3;
  }

  .receipt-image {
    width: 60px;
    height: 60px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.order-remark {
  line-height: 32px;
}

.order-info-box {
  .order-info-card {
    width: 400px;
    height: 190px;
    border: 1px dashed #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 0 40px;
    div {
      margin-top: 9px;
    }
    &.card-red {
      border-color: $base-red;
      color: $base-orange;
      padding: 40px 0 0 130px;
      div {
        margin-top: 15px;
      }
    }
    .amount-msg {
      color: #333;
      font-size: 12px;
      margin-top: 5px !important;
    }
  }
}
.list-text {
  padding-bottom: 5px;
  display: inline-block;
}
.order-input {
  display: flex;
  margin: 10px 0;
  .el-input {
    width: 200px;
  }
}
.prints-img {
  display: flex;
  align-items: center;
  .print-img {
    width: 40px;
    height: 40px;
    margin-right: 5px;
  }
}
.prints-ai {
  margin: 10px 0;
}
.prints-info {
  & > div {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.sap-btn {
  text-align: right;
  margin-bottom: 15px;
}
.price-msg {
  margin-top: -5px;
}
.price-info {
  font-size: 12px;
  color: #999;
}
</style>
